import {register} from '@shopify/theme-sections';

export default register('page-downloads', {
  onLoad() {
    // If we are in the theme editor do nothing
    if (window.top.ThemeEditor || window.top.ThemeEditorAPI || window.Shopify.designMode) {
      return;
    }

    const pageContent = this.container.querySelector('[data-downloads-content]');
    if (!pageContent) {
      return;
    }

    // Find a matching download based on the 'file' reference value in the url
    const redirectDelay = 2000;
    const params = new URLSearchParams(window.location.search);
    const reference = params.get('file');
    const allDownloads = window.theme.downloads || [];
    const download = allDownloads.find(download => download.reference === reference);
    if (!download) {
      // Redirect to home page
      pageContent.innerHTML = window.theme.strings.fileNotFoundHTML;
      setTimeout(() => {
        window.location.replace(window.location.origin);
      }, redirectDelay);
      return;
    }

    const {fileURL, trackDownload} = download;
    const alreadyDownloaded = sessionStorage.getItem('alreadyDownloaded')
      ? JSON.parse(sessionStorage.getItem('alreadyDownloaded'))
      : [];

    // Add download details to the page
    pageContent.innerHTML = window.theme.strings.downloadInProgressHTML.replace('{{ link }}', fileURL);

    // If this download is in the list of alreadyDownloaded return
    if (alreadyDownloaded.includes(reference)) {
      return;
    }

    alreadyDownloaded.push(reference);
    sessionStorage.setItem('alreadyDownloaded', JSON.stringify(alreadyDownloaded));

    // If tracking is enabled send tracking details to Klaviyo and GTM
    if (trackDownload) {
      window._learnq = window._learnq || [];
      window._learnq.push([
        'track',
        'File Downloaded',
        {
          Reference: reference,
          Url: fileURL,
        },
      ]);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'fileDownloaded',
        details: {
          reference: reference,
          url: fileURL,
        },
      });
    }

    // Trigger click to start download
    const downloadLink = pageContent.querySelector('a');
    if (!downloadLink) {
      return;
    }
    setTimeout(() => {
      downloadLink.click();
    }, redirectDelay);
  },
});
